import { createSlice } from "@reduxjs/toolkit";

export const transportQuotationsSlice = createSlice({
  name: "transportQuotations",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    filteredRecords: 0,
    isLoading: false,
  },
  reducers: {
    getTransportQuotationsLoadState: (state, action) => {
      state.isLoading = true;
    },
    addTransportQuotations: (state, action) => {
      const listObj = {};
      action.payload.solutions.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.solutions.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
  },
});

export const { getTransportQuotationsLoadState, addTransportQuotations } =
  transportQuotationsSlice.actions;

export default transportQuotationsSlice.reducer;
